// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1xxnU","errorLogs":"EditorFooter_errorLogs__2hGma"};